import { AlertTriangle } from '@crehana/compass.icons.outline/v2/alert-triangle';
import { Refresh } from '@crehana/compass.icons.outline/v2/refresh';
import { Button } from '@crehana/compass.ui/v3/button';
import { SemanticIcon } from '@crehana/compass.ui/v3/semantic-icon';

import { useTranslation } from '../i18n';

type TWidgetErrorProps = {
  onRetry: () => void;
};

export const WidgetError = ({ onRetry }: TWidgetErrorProps) => {
  const { t } = useTranslation();

  return (
    <div
      className="tw-cds-bg-primary tw-cds-border-color-default tw-rounded-1.2 tw-border tw-p-1.6 tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-1.6 tw-py-4.8"
      data-testid="widget-error"
    >
      <SemanticIcon type="alert" icon={AlertTriangle} />

      <div className="tw-flex tw-flex-col tw-items-center tw-gap-0.8 tw-text-center">
        <span className="tw-cds-font-subtitle-02 tw-cds-text-primary">
          {t('error_carga_title')}
        </span>
        <span className="tw-cds-font-body-01 tw-cds-text-subtle tw-max-w-[280px]">
          {t('error_carga_desc')}
        </span>
      </div>

      <Button
        type="button"
        variant="primary"
        startIcon={Refresh}
        onClick={onRetry}
      >
        {t('reintentar')}
      </Button>
    </div>
  );
};
